import { useEffect } from 'react';

/**
 * Preload a list of image URLs as early as possible.
 * Creates Image objects so the browser caches them before first paint.
 */
export default function useImagePreload(urls: string[]) {
  useEffect(() => {
    const images: HTMLImageElement[] = [];

    urls.forEach((url) => {
      if (!url) return;
      const img = new Image();
      // Hint the browser to prioritize decoding while we keep network eager
      // This doesn't block rendering and warms the cache for later usage
      // @ts-expect-error: fetchPriority is a valid browser attribute
      img.fetchPriority = 'high';
      img.decoding = 'async';
      img.loading = 'eager';
      img.src = url;
      images.push(img);
    });

    return () => {
      // Allow GC to reclaim memory
      images.splice(0, images.length);
    };
  }, [urls]);
}
